const modules = {
  dashboard: {
    target: ".dashboard",
    contentTitle: "Home",
    contentText: "Vortex Landing page with quick links to the important modules.",
  },
  settings: {
    target: ".settings",
    contentTitle: "Settings",
    contentText:
      "Change the Vortex global settings, add/update/remove connections, configure SSO settings and SMTP settings and customize Vortex Landing Page",
  },
  users: {
    target: ".users",
    contentTitle: "Users",
    contentText: "Add and Manage Vortex users with permissions and SageMaker configuration.",
  },
  datacatalog: {
    target: ".data_catalog",
    contentTitle: "Data Catalog",
    contentText: "Quickly view the Metadata of Datasets added.",
  },
  reports: {
    target: ".reports",
    contentTitle: "Reports",
    contentText: "View complete audit reports of workspace and usage of SageMaker and Snowflake.",
  },
  guide: {
    target: ".guide",
    contentTitle: "Guide",
    contentText: "Download the Vortex Guide.",
  },
  workspaces: {
    target: ".workspaces",
    contentTitle: "Workspaces",
    contentText:
      "Create or Manage one or multiple Workspaces and configure your workflow using datasets and entities, configure various jobs, view the imported and refined data and access Jupyter using SageMaker.",
  },
  cases: {
    target: ".cases",
    contentTitle: "Cases",
    contentText: "View Steward Cases generated after running Data Mastering MDM jobs or Data Deduplication.",
  },
  processqueue: {
    target: ".processqueue",
    contentTitle: "Process Queue",
    contentText: "Check the status of File uploads.",
  },
  notifcationsList: {
    target: ".notifcationsList",
    contentTitle: "Notifications",
    contentText: "Check the status of latest workspace related changes.",
  },
  avatarIcon: {
    target: ".avatarIcon",
    contentTitle: "Profile",
    contentText: "View your profile details and current vortex instance information.",
  },
};

const Topbar = [modules.processqueue, modules.notifcationsList, modules.avatarIcon];

const steps = {
  SysAdmin: {
    Sidebar: [modules.dashboard, modules.settings, modules.users, modules.datacatalog, modules.reports, modules.guide],
    Topbar,
  },
  BusinessAdmin: {
    Sidebar: [modules.dashboard, modules.workspaces, modules.reports, modules.guide],
    Topbar,
  },
  UserAdmin: {
    Sidebar: [modules.dashboard, modules.users],
    Topbar,
  },
  DataManager: {
    Sidebar: [modules.dashboard, modules.datacatalog, modules.workspaces, modules.reports, modules.guide],
    Topbar,
  },
  DataAnalyst: {
    Sidebar: [modules.dashboard, modules.datacatalog, modules.workspaces, modules.reports, modules.guide],
    Topbar,
  },
  DataSteward: {
    Sidebar: [modules.dashboard, modules.cases, modules.guide],
    Topbar,
  },
};

const stepsData = [];

for (const [role, roleSteps] of Object.entries(steps)) {
  const roleData = {};

  for (const [section, sectionSteps] of Object.entries(roleSteps)) {
    roleData[section] = sectionSteps.map(({ target, contentTitle, contentText }) => ({
      target,
      content: (
        <div>
          <h3 style={{ marginBottom: "15px" }}>
            <strong>{contentTitle}</strong>
          </h3>
          <p>{contentText}</p>
        </div>
      ),
    }));
  }

  stepsData.push({ [role]: roleData });
}

export default stepsData;
